import {
  ChakraFlex,
  ChakraSpacer,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

const { h5 } = EquipUITheme.typography;

interface LayoutProps {
  children: React.ReactNode;
  cta?: React.ReactNode;
  minWidth?: string;
  title: string;
  titleId: string;
  width?: string;
}

const Layout = ({
  children,
  cta,
  minWidth,
  title,
  titleId,
  width = '100%',
}: LayoutProps) => (
  <ChakraFlex
    direction="column"
    marginBottom="16px"
    minWidth={minWidth}
    width={width}
  >
    <ChakraFlex alignItems="center" marginBottom="12px">
      <ChakraText {...h5} id={`${titleId}__title`} lineHeight="40px">
        {title}
      </ChakraText>
      <ChakraSpacer />
      {cta}
    </ChakraFlex>
    {children}
  </ChakraFlex>
);

export default Layout;
